import React from 'react';
import { Link } from 'react-router-dom';
import { X, Plus, Minus, ShoppingBag, Trash2 } from 'lucide-react';
import { useCart } from '../../context/CartContext';

const CartDrawer = () => {
  const { cartItems, isCartOpen, setIsCartOpen, updateQuantity, removeFromCart, getCartTotal } = useCart();

  const formatPrice = (price) => {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      minimumFractionDigits: 0,
    }).format(price);
  };

  return (
    <>
      {/* Overlay */}
      <div
        className={`fixed inset-0 bg-black/50 z-50 transition-opacity duration-300 ${
          isCartOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
        onClick={() => setIsCartOpen(false)}
      />

      {/* Drawer */}
      <div
        className={`fixed right-0 top-0 bottom-0 w-full max-w-md bg-white z-50 transform transition-transform duration-300 ${
          isCartOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-4 border-b">
            <h2 className="text-lg font-light tracking-wider">ALIŞVERİŞ SEPETİ</h2>
            <button
              onClick={() => setIsCartOpen(false)}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors"
            >
              <X size={20} />
            </button>
          </div>

          {/* Cart Items */}
          <div className="flex-1 overflow-y-auto py-4">
            {cartItems.length === 0 ? (
              <div className="flex flex-col items-center justify-center h-full text-gray-400">
                <ShoppingBag size={48} className="mb-4" />
                <p className="text-sm">Sepetiniz boş</p>
              </div>
            ) : (
              <div className="space-y-4 px-6">
                {cartItems.map((item) => (
                  <div
                    key={`${item.id}-${item.selectedSize}-${item.selectedColor}`}
                    className="flex gap-4 pb-4 border-b"
                  >
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-24 h-24 object-contain bg-gray-50"
                    />
                    <div className="flex-1">
                      <h3 className="text-sm font-medium mb-1">{item.name}</h3>
                      <p className="text-xs text-gray-500 mb-1">{item.selectedSize} cm</p>
                      {item.selectedColor && (
                        <p className="text-xs text-gray-500 mb-1">{item.selectedColor}</p>
                      )}
                      <p className="text-sm font-medium">{formatPrice(item.price)}</p>
                      <div className="flex items-center gap-3 mt-2">
                        <button
                          onClick={() =>
                            updateQuantity(item.id, item.selectedSize, item.selectedColor, item.quantity - 1)
                          }
                          className="p-1 hover:bg-gray-100 rounded transition-colors"
                        >
                          <Minus size={14} />
                        </button>
                        <span className="text-sm w-8 text-center">{item.quantity}</span>
                        <button
                          onClick={() =>
                            updateQuantity(item.id, item.selectedSize, item.selectedColor, item.quantity + 1)
                          }
                          className="p-1 hover:bg-gray-100 rounded transition-colors"
                        >
                          <Plus size={14} />
                        </button>
                        <button
                          onClick={() => removeFromCart(item.id, item.selectedSize, item.selectedColor)}
                          className="p-1 hover:bg-gray-100 rounded transition-colors ml-auto text-gray-400 hover:text-red-500"
                        >
                          <Trash2 size={14} />
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Footer */}
          {cartItems.length > 0 && (
            <div className="border-t px-6 py-4 space-y-4">
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-500">Ara Toplam</span>
                <span className="font-medium">{formatPrice(getCartTotal())}</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-500">Kargo</span>
                <span className="text-green-600">Ücretsiz</span>
              </div>
              <div className="flex items-center justify-between pt-2 border-t">
                <span className="font-medium">Toplam</span>
                <span className="text-lg font-medium">{formatPrice(getCartTotal())}</span>
              </div>
              <Link
                to="/sepet"
                onClick={() => setIsCartOpen(false)}
                className="block w-full bg-black text-white text-center py-4 text-sm tracking-wider hover:bg-gray-900 transition-colors"
              >
                SEPETE GİT
              </Link>
              <button
                onClick={() => setIsCartOpen(false)}
                className="block w-full text-center py-3 text-sm tracking-wider border border-black hover:bg-gray-50 transition-colors"
              >
                ALIŞVERİŞE DEVAM ET
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CartDrawer;
